<div [formGroup]="formGroup" *ngIf="controlName && currentDate" class="date-picker">
  <mat-form-field appearance="outline" [class.w-full]="width === 'full'">
    <input
      class="hide-hint"
      matInput
      mask="00/00/0000"
      [disabled]="disabled"
      [(ngModel)]="dateValFormatted"
      [ngModelOptions]="{ standalone: true }"
      (blur)="maskChange()"
      [placeholder]="placeholder"
      [required]="required"
    />
    <input
      class="hidden"
      (blur)="dateSelected()"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="dateVal"
      type="text"
      (dateChange)="dateSelected()"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [required]="required"
      [disabled]="disabled"
    />
    <mat-datepicker-toggle
      [disabled]="disabled"
      matIconSuffix
      [for]="picker"
      (click)="onDatePickerToggle()"
    >
      <img
        [ngStyle]="{ opacity: disabled ? 0.5 : 1 }"
        style="
          width: 17px;
          margin-bottom: 2px;
          margin-left: 10px;
          margin-top: 5px;
        "
        matDatepickerToggleIcon
        src="/assets/calender-icon.svg"
        alt=""
      />
    </mat-datepicker-toggle>
    <mat-datepicker #picker (closed)="maskChange()" [dateClass]="highlightCustomToday"></mat-datepicker>
    <!-- <mat-error>
      {{ controlName }} field is required
    </mat-error> -->
  </mat-form-field>
</div>
